export default {
  "foot": {
    "title": "Giocatori di Century Games",
    "p1": "Inserisci il tuo ID Utente, paga la ricarica. L'importo verrà aggiornato direttamente nel tuo account associato. Se non viene visualizzato, ricarica il gioco o contatta l'assistenza clienti, se necessario.",
    "p2": "Se hai domande, non esitare a contattare il servizio clienti. Grazie per il supporto!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Termini di Servizio",
    "policy": "Politiche sulla Privacy",
    "descriptionTitle": "Come funziona?"
  },
  "accept": {
    "title": "Questo sito web utilizza i cookie per migliorare la tua esperienza di navigazione. Leggi le nostre <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Politiche sulla Privacy</a> per info su ciò che raccogliamo sul nostro sito web. Continuando a usare questo sito, accetti che possiamo archiviare e accedere ai cookie sul tuo dispositivo.",
    "decline": "Rifiuta",
    "accept": "Accetta"
  },
  "game": {
    "inapptext": "Oppure Accedi dal Gioco",
    "loginfail": "Accesso Fallito",
    "logintip": "Se il gioco non è riuscito ad autorizzare, aggiornalo all'ultima versione o prova un altro browser.",
    "reloadmsg": "Tocca il pulsante \"Ricarica\" ​​per ottenere il risultato di accesso.",
    "reload": "Ricarica",
    "appnotice": "Se vuoi accedere tramite l'app del gioco, usa un browser esterno per aprire lo store.",
    "changeaccount": "Vuoi davvero uscire dal tuo account?",
    "login": "Accedi",
    "notice": "Avviso",
    "confirm": "Conferma",
    "loginuserid": "ID Utente",
    "palceholder": "Inserisci ID Utente",
    "okbtn": "OK",
    "loginbtn": "Accedi dal Gioco",
    "changebtn": "Oppure Accedi dal Gioco",
    "useTitle": "ACCOUNT",
    "checkBtn": "Controlla",
    "findid": "Non trovi il tuo ID Utente?",
    "checktext": "Normalmente si trova nelle impostazioni, tocca il punto interrogativo per maggiori info.",
    "username": "Nickname:",
    "userId": "ID Utente:",
    "packageTitle": "IMPORTO DI RICARICA",
    "edit": "Modifica",
    "paymentTitle": "METODO DI PAGAMENTO",
    "total": "Totale",
    "goPay": "Paga Ora",
    "noSelectPackageTips": "Non hai selezionato alcun importo",
    "payFail": "PAGAMENTO FALLITO",
    "camelPayfail": "Pagamento non riuscito",
    "payFailTips1": "Contatta il Servizio Clienti Adyen",
    "payFailTips2": "Contatta il Servizio Clienti PayPal",
    "paySuccess": "PAGAMENTO RIUSCITO",
    "paySuccessTips2": "Ricarica il gioco prima di contattare il servizio clienti per non aver ricevuto il tuo acquisto!",
    "camelPaySuccess": "Pagamento Riuscito",
    "transactionId": "ID Transazione",
    "paySuccessTips": "La consegna dell'articolo potrebbe richiedere un momento, attendi",
    "deliveryFail": "CONSEGNA FALLITA",
    "deliveryFailTips": "Contatta il servizio clienti",
    "orderTitle": "Riepilogo dell'ordine",
    "paidWith": "Metodo di Pagamento",
    "orderID": "ID Transazione",
    "payStatus": "Stato del Pagamento",
    "orderTotal": "Prezzo Totale",
    "transactionDate": "Data della Transazione",
    "goOnPay": "Acquista di Nuovo",
    "getInvoice": "Ricevuta",
    "camelDeliveryFail": "Errore di Consegna",
    "confirmOrder": "CONFERMA DELL'ORDINE",
    "confirmFollow": "Conferma quanto segue:",
    "nickname": "Nickname",
    "packageName": "Oggetti",
    "totalPayment": "Prezzo Totale",
    "confirmPayWith": "Metodo di Pagamento",
    "confirmAndGoOn": "Conferma & Procedi al Pagamento",
    "orderCancel": "Annulla",
    "getInvoiceTitle": "INVIA VIA EMAIL",
    "getInvoiceTips": "Se vuoi ricevere la ricevuta via email, inserisci un indirizzo email.",
    "getInvoiceTips1": "Inserisci il tuo indirizzo email per ricevere la ricevuta",
    "getInvoiceTips2": "Accetti la raccolta e l'archiviazione del tuo indirizzo email.",
    "getInvoiceTips3": "Accetti di ricevere email su sconti, promozioni e altro per i nostri giochi via email.",
    "invoiceSend": "Invia",
    "sendSuccess": "Email della Ricevuta Inviata",
    "id404": "ID Utente non trovato",
    "packageLoadingText": "Aggiornamento oggetti in negozio...",
    "taxTips": "Il prezzo include le tasse",
    "adyenTips": "Il servizio di pagamento è fornito da Adyen, che opera con una licenza bancaria ed è supervisionato dalla Banca Centrale Olandese. Per qualsiasi domanda sulle sue certificazioni, fare riferimento a <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Per quanto riguarda il modo in cui proteggono i tuoi dati, fai riferimento a <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "Il servizio di pagamento è fornito da PayPal. Per quanto riguarda la protezione dei tuoi dati, fai riferimento a <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Il tuo paese/regione preferito è ${servercountry}. Vuoi cambiare paese e valuta?",
    "paypalBtn": "Paga con Carta",
    "paypalOr": "Oppure",
    "paypalCard1": "Nome Titolare Carta (facoltativo)",
    "paypalCard2": "Numero della Carta",
    "checkUserID": "Link",
    "success": "SUCCESSO",
    "changeCurrencyContent": "Vuoi cambiare la regione e la valuta per adattarle alle tue impostazioni di gioco: ${servercountry}?",
    "productDescription": "I Dollaroni equivalgono al denaro contante e possono essere usati per acquistare pacchetti e offerte nel gioco.",
    "payButton": "PAGA",
    "userIdNotice": "Inserisci il tuo ID Utente per collegare prima il tuo account di gioco",
    "account": "Account",
    "card": "Carta",
    "notification": "Inserisci il tuo ID Utente per collegare l'account, seleziona gli oggetti desiderati, poi paga con il tuo metodo di pagamento preferito. Dopo aver ricaricato il gioco, gli oggetti acquistati appariranno nel tuo account, pronti per l'uso.\n\nSe hai domande, non esitare a contattare il supporto clienti nel gioco.",
    "rongluRank": "Livello Fornace:",
    "tips": "Come si usa?",
    "checkTIps1": "Ho letto e accetto le <a :href=\"policyUrl\">\"Politiche sulla Privacy\"</a>, <a :href=\"serviceURl\">\"Termini e Condizioni\"</a> e <a :href=\"paymentURl\">\"Termini di Pagamento\"</a>.",
    "checkTIps2": "Leggi e accetta le condizioni",
    "selectTips": "(Verrà selezionata la valuta di acquisto più recente nel gioco)",
    "koPayTips": "Se la tua carta di credito utilizza il Won Coreano come valuta estera, verrà utilizzato il servizio di conversione dinamica della valuta (DCC) e potrebbe essere addebitata una commissione di gestione aggiuntiva da un proxy di terze parti e non da questo sito web.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Ricevuta",
    "transactionId": "ID Transazione",
    "transactionDate": "Data Transazione",
    "totalAmount": "Importo Totale",
    "paymentMethod": "Metodo di Pagamento",
    "description": "Descrizione",
    "game": "Gioco",
    "quantity": "Quantità",
    "price": "Prezzo",
    "amount": "Importo",
    "total": "Importo Totale",
    "footTitle": "Note",
    "footContent": "Grazie per il supporto a Century Games!",
    "button1": "Ottieni la Ricevuta",
    "button2": "Indietro Senza Ricevuta",
    "giveupInvoice": "Non riceverai la ricevuta per l'ordine. Confermi?"
  },
  "payment": {
    "card": "Carta di Credito/Debito",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "REGIONE/PAESE",
    "Africa": "Africa",
    "America": "America",
    "Asia": "Asia",
    "Europe": "Europa",
    "Oceania": "Oceania",
    "ZA": "Sudafrica",
    "US": "Stati Uniti",
    "HK": "Hong Kong, Cina",
    "JP": "Giappone",
    "KR": "Corea",
    "SG": "Singapore",
    "SA": "Arabia Saudita",
    "IQ": "Iraq",
    "TW": "Taiwan, Cina",
    "TH": "Thailandia",
    "GB": "Regno Unito",
    "AU": "Australia",
    "countryLanguage1": "LINGUA",
    "AE": "Emirati Arabi Uniti",
    "DE": "Germania",
    "PT": "Portogallo",
    "RU": "Russia",
    "ES": "Spagna",
    "CH": "Svizzera",
    "TR": "Turchia",
    "KW": "Kuwait",
    "QA": "Qatar",
    "PL": "Polonia",
    "ID": "Indonesia",
    "IT": "Italia",
    "IN": "India",
    "FR": "Francia",
    "CA": "Canada",
    "NL": "Olanda",
    "AT": "Austria",
    "RS": "Serbia",
    "SE": "Svezia",
    "MY": "Malesia",
    "BE": "Belgio",
    "DK": "Danimarca",
    "FI": "Finlandia",
    "PH": "Filippine",
    "NO": "Norvegia",
    "BR": "Brasile",
    "NZ": "Nuova Zelanda",
    "UA": "Ucraina",
    "RO": "Romania"
  },
  "extra_info": {
    "kingdom": "Stato: #"
  },
  "adyen": {
    "note": "Il servizio di pagamento è fornito da Adyen, che offre transazioni sicure con il più alto livello di certificazione PCI-DSS da parte di organizzazioni internazionali di carte di credito, supportando sia i pagamenti con carta nazionali che esteri.",
    "note2": "Nota: seleziona \"Salva per prossimo pagamento\" per salvare i dati della tua carta nel browser per pagamenti futuri."
  },
  "pay": {
    "error1": "Se qualcosa va storto, riprova più tardi o usa un altro metodo di pagamento. Contatta l'assistenza clienti se hai altre domande."
  },
  "meta": {
    "title": "Negozio di Family Farm Adventure",
    "description": "Il Negozio di Family Farm Adventure è il negozio ufficiale del gioco e offre ai giocatori un canale di ricarica scontato e pacchetti di gioco.",
    "keywords": "fattoria, coltivazione, mercato, potenzia, esplora, mappa, personaggi, livello, simulazione, strategia, pagamento, negozio, ricarica, pagamento"
  }
};


// WEBPACK FOOTER //
// ./src/lang/IT.js